import { styled } from '../../../theme/stitches.config';

export const SMPSportEntity = styled.withConfig({ componentId: 'CommonWidget', displayName: 'SportEntity' })('a', {
  // Reset
  boxSizing: 'border-box',
  display: 'flex',
  fontFamily: '$primaryFontFamily',
  fontSize: '$3',
  alignItems: 'center',
  flex: '1 1 0',
  gap: '$2',
  textDecoration: 'none',
  outline: 'none',
  variants: {
    direction: {
      row: {
        fd: 'row',
      },
      column: {
        fd: 'column',
      },
      rowReverse: {
        fd: 'row-reverse',
      },
      columnReverse: {
        fd: 'column-reverse',
      },
    },
    variant: {
      horizontal: {
        fd: 'row',
        textAlign: 'left',
        py: '$1',
      },
      horizontalReverse: {
        fd: 'row-reverse',
        textAlign: 'right',
      },
      vertical: {
        fd: 'column',
        textAlign: 'center',
      },
      tennisTeamDouble: {
        flex: 'initial',
        fd: 'row',
        textAlign: 'left',
        py: '$1',
      },
    },
  },
});
